import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { AuthService } from 'app/core/services/auth.service';
import { LaboratoryHttpHeaderService } from 'app/core/services/prothesis-api/laboratory-http-header.service';
import { WorkingLaboratoryService } from 'app/core/services/prothesis-api/working-laboratory.service';
import { ProgressBarStorageCardModelHelper } from 'app/shared/components/cards/progress-bar-storage-card/model-helpers/progress-bar-storage-card-model-helper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StorageBannerModel } from './storage-banner-model';
import { StorageBannerModelHelper } from './storage-banner-model-helper';
import { MatCardContent } from '@angular/material/card';
import { NgClass } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-storage-banner',
  styleUrls: ['./storage-banner.component.scss'],
  templateUrl: './storage-banner.component.html',
  imports: [MatCardContent, NgClass],
})
export class StorageBannerComponent implements OnInit {
  public storageBanner: StorageBannerModel;
  public storageUsagePercentageWarning = ProgressBarStorageCardModelHelper.storageUsagePercentageWarning;
  public storageUsagePercentageWarning2 = ProgressBarStorageCardModelHelper.storageUsagePercentageWarning2;
  public subscriptionSettingsFlag: boolean;

  private _authService = inject(AuthService);
  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _laboratoryHttpHeaderService = inject(LaboratoryHttpHeaderService);
  private _unsubscribeAll: Subject<void>;
  private _workingLaboratoryService = inject(WorkingLaboratoryService);

  public constructor() {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  public ngOnInit(): void {
    this._laboratoryHttpHeaderService.onHttpHeaderChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      const httpHeader = this._laboratoryHttpHeaderService.getHttpHeader();
      this.storageBanner = StorageBannerModelHelper.fromHttpHeader(httpHeader);

      // Mark for check
      this._changeDetectorRef.markForCheck();
    });

    this._authService.areaConfiguredFlag$.subscribe((areaConfiguredFlag: boolean) => {
      if (areaConfiguredFlag && this._workingLaboratoryService.laboratoryRole) {
        this.subscriptionSettingsFlag = this._workingLaboratoryService.laboratoryRole?.subscriptionSettingsFlag;
      }
    });
  }
}
